import useSidebarMenu from './useSidebarMenu';

export default useSidebarMenu;
